import TemplateView from '../TemplateView'
import {TaskManagementViewMode} from './constants'
import KanbanConfiguratorPanel from './kanban/components/KanbanConfiguratorPanel'
import TaskListConfiguratorPanel from './tasksTable/TaskListConfiguratorPanel'
import AddFiltersContainer from './tasksTable/AddFiltersContainer'

export default class ConfiguratorPanelContainer extends TemplateView {
    constructor({
        onAllSelectedChanged = allSelected => {},
        onMinimizedCardsChanged = minimizedCards => {},
        onCollapseAllChanged = isAllCollapsed => {},
    }) {
        super()

        this.state = {
            viewMode: null,
            minimizedCards: false,
            showSelection: false,
            allTasksSelected: false,
            collapsedProjects: {
                all: false,
                idsSet: {},
            },
            singleCPSelection: {},
            ignoreProjectCollapse: false,
            isTWSEnabled: false,
        }

        this.callbacks = {
            onAllSelectedChanged,
            onMinimizedCardsChanged,
            onCollapseAllChanged,
        }

        this.onStatePropertyChanged('viewMode', this._handleViewModeChanges)
        this.onStatePropertyChanged('isTWSEnabled', (isTWSEnabled) => this.$separator.toggle(isTWSEnabled))

        this.onAnyStatePropertyChanged(
            [
                'allTasksSelected',
                'minimizedCards',
                'showSelection',
                'collapsedProjects',
                'singleCPSelection',
                'ignoreProjectCollapse',
            ],
            state => this.kanbanConfiguratorPanel.setState(state)
        )
    }

    _handleViewModeChanges = (viewMode) => {
        this.kanbanConfigurator.toggle(viewMode === TaskManagementViewMode.KANBAN)
        this.$taskTableConfigurator.toggle(viewMode === TaskManagementViewMode.TABLE)
    }

    templateHtml() {
        return "<div class='configuratorPanel'>" +
               "    <div class='kanbanConfigurator'/>" +
               "    <div class='taskTableConfigurator'/>" +
               "    <div class='taskAddFiltersContainer atNextMount'/>" +
               "    <div class='configuratorSeparator'/>" +
               "</div>"
    }

    afterRender() {
        this.$taskTableConfigurator = this.find(".taskTableConfigurator")
        new TaskListConfiguratorPanel().init(this.$taskTableConfigurator)

        this.kanbanConfigurator = this.find(".kanbanConfigurator")
        this.kanbanConfiguratorPanel = new KanbanConfiguratorPanel({
            onAllSelectedChanged: this.callbacks.onAllSelectedChanged,
            onMinimizedCardsChanged: this.callbacks.onMinimizedCardsChanged,
            onCollapseAllChanged: this.callbacks.onCollapseAllChanged,
        }).init(this.kanbanConfigurator);

        this.addFiltersContainer = new AddFiltersContainer().init(this.find(".taskAddFiltersContainer"))

        this.$separator = this.find(".configuratorSeparator")
        this.$separator.hide()
    }
}



// WEBPACK FOOTER //
// ./web/js/taskManagement/ConfiguratorPanelContainer.js